import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var PhoneOffSvg = function PhoneOffSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.08 22.249 2 3.169l.92-.92 2.359 2.359V2.926H18.72V18.05L22 21.329zm-3.66-5.5V4.228H6.58v1.682z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.265 16.802h3.47v1.301h-3.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.58 9.214V20.27h10.624v1.301H5.279V9.214z"
  }));
};
export var PhoneOff = function PhoneOff(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: PhoneOffSvg
  }));
};